import React from 'react';
import {TileFooterProps} from './TileTypes';
import {Size} from '../types';
import styled from 'styled-components';
import {RenderTileItem} from './TileCommonItems';
import {COLORS} from '../styles';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  min-height: 56px;
  box-sizing: border-box;

  &.small {
    padding: 0 16px;
    min-height: 56px;
    gap: 4px;
  }

  &.medium {
    padding: 0 20px;
    min-height: 64px;
    gap: 4px;
  }

  &.large {
    padding: 0 24px;
    min-height: 80px;
    gap: 8px;
  }
`;

const LeftItemContainer = styled.div`
  flex: 1
`;

const RightItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  color: ${props => COLORS.generateToken({componentType:'text',defaultVariant:'subtle'}, props.theme)};
`;

const TileFooter: React.FunctionComponent<TileFooterProps & { size: Size }> = ({buttons, leftItem, size}) => {

  return (
    <Wrapper className={size}>
      <LeftItemContainer>{leftItem && RenderTileItem(leftItem, size)}</LeftItemContainer>
      <RightItemContainer>{buttons && buttons.map((value, index) => RenderTileItem(value, size, index))}</RightItemContainer>
    </Wrapper>
  )
}

export default TileFooter;
